@if (inputControl) {
  <div [class.input-container--full-width]="isFullWidth" [class.input-container--wide]="isWide"
    class="input-container">
    @if (inputSubLabel || inputLabel || helpContent) {
      <div style="display: inline-grid; grid-template-columns: auto auto; grid-template-rows: auto; grid-column-gap: 5px"
        >
        @if (inputLabel) {
          <label [for]="formatInputID(inputLabel)" class="input-label">{{inputLabel}}</label>
        }
        @if (inputSubLabel) {
          <div class="helper-text">{{inputSubLabel}}</div>
        }
        @if (helpContent) {
          <rn-help-info-popup class="info-popup">
            {{helpContent}}
          </rn-help-info-popup>
        }
      </div>
    }
    <!-- NON-REQUIRED FIELD VALIDATION: Unified error display with character count -->
    <input (blur)="emitInputEvent($event)"
      (keyup)="emitInputEvent($event)"
      [class.input--has-error]="isInvalidOrEmpty()"
      [formControl]="inputControl"
      [id]="formatInputID(inputLabel)"
      [placeholder]="placeholderText"
      [readonly]="readOnlyAttr()"
      [type]="type"
      class="input form-control"
      spellcheck="false">
    <app-error-display 
      [control]="inputControl"
      [untouchedIfEmpty]="untouchedIfEmpty"
      [showCharacterCount]="maxLength !== null"
      [maxLength]="maxLength"
      [currentLength]="inputControl?.value?.length || 0">
    </app-error-display>
  </div>
}

<ng-content select="[input-info-box]"></ng-content>
